import moment from 'moment'
import { formatDate, formatDuration } from '../Recordings/columns'
import { UserPrefsColumn, GOAL_COLUMN_CATEGORY, ACTION_COLUMN, ActionColumnKey, Contact, CategoryColumns, Column } from './constants'

export const mapColumns = (columns: UserPrefsColumn[], contact: Contact) => {
  const row = columns.map(column => {
    let value
    if (column.category === GOAL_COLUMN_CATEGORY.METADATA) {
      value = (() => {
        const metadataField = contact?.metadata && contact.metadata[column.key] ? contact.metadata[column.key] : null
        return { translate: false, value: metadataField?.value }
      })()
    } else {
      value = (() => {
        switch (column.key) {
          /**  category: date_fields */
          case 'date':
            return { translate: false, value: formatDate(contact.startTime, contact.tz) }
          case 'time':
            return {
              translate: false,
              value: moment(contact.startTime)
                .tz(contact.tz)
                .format('hh:mm a')
                .toUpperCase(),
            }
          case 'tz':
            return { translate: false, value: contact.tz }
          /**  category: contact_fields */
          case 'id':
            return { translate: false, value: contact.id }
          case 'contact_type':
            return contact.contactType ? { translate: true, value: contact.contactType?.toLowerCase() } : { translate: false, value: '' }
          case 'channel':
            return { translate: true, value: contact.channel }
          case 'call_duration':
            return { translate: false, value: formatDuration(contact.callDuration) }
          /**  category: organazation_fields */
          case 'last_name':
            return { translate: false, value: contact.agent.lastName }
          case 'first_name':
            return { translate: false, value: contact.agent.firstName }
          /**  category: goal_fields */
          case 'goalName':
            return { translate: false, value: contact?.goal?.name }
          case 'goalId':
            return { translate: false, value: contact?.goal?.id }
          case 'goalDue':
            return { translate: false, value: formatDate(contact?.goal?.dueDate, contact.tz) }
          case 'goalInstruction':
            return { translate: false, value: contact?.goal?.instruction }
          case 'goalActionName':
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
            return { translate: true, value: ACTION_COLUMN[contact?.goal?.action as ActionColumnKey] }
          /**  category: evaluation_fields */
          case 'evaluation_score':
            return {
              translate: false,
              value:
                contact.evaluation && (contact.evaluation.totalScore || contact.evaluation.totalScore === 0)
                  ? Number(contact?.evaluation?.totalScore).toFixed(2)
                  : '',
            }
          case 'evaluation_date':
            return {
              translate: false,
              value: contact.evaluation !== null ? formatDate(contact.evaluation.evaluated, contact.tz) : '',
            }
          case 'evaluator_name':
            return { translate: false, value: contact.evaluator.displayId }
          case 'evaluation_form_name':
            return { translate: false, value: contact.evalForm?.name }
          default:
            return { translate: false, value: '' }
        }
      })()
    }
    return {
      label: column.id,
      value,
    }
  })


  return row.reduce((acc: Record<string, unknown>, curr: { label: string, value: unknown }) => {
    acc[curr?.label] = curr.value
    return acc
  }, {})
}

export const convertToColumnDataJson = (columns: UserPrefsColumn[]): { columnData: CategoryColumns[] } => {
  const categoryMap: Record<string, Column[]> = {}

  columns.forEach(col => {
    const { category } = col
    if (!categoryMap[category]) {
      categoryMap[category] = []
    }
    categoryMap[category]?.push(col)
  })

  const categoryColumnsArray: CategoryColumns[] = Object.entries(categoryMap).map(
    ([category, cols]) => ({
      category,
      columns: cols,
    }),
  )

  return { columnData: categoryColumnsArray }
}
